<template>
  <ap3-access-gate>
    <router-view />
  </ap3-access-gate>
</template>

<script>
import ap3AccessGate from '@/components/ap3AccessGate';

export default {
  components: { ap3AccessGate },
};
</script>

<style></style>
